import React from 'react';
import { createRoot } from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import keycloak from './keycloak';
import { App } from './App';

import './assets/styles/main.scss';
import './assets/styles/global.scss';
import AuthService from './services/auth/Auth.services';

const persistTokens = () => {
    if (keycloak.token) localStorage.setItem('access_token', keycloak.token);
    if (keycloak.refreshToken) localStorage.setItem('refresh_token', keycloak.refreshToken);
    if (keycloak.idToken) localStorage.setItem('id_token', keycloak.idToken);

    const exp = keycloak.tokenParsed?.exp;
    if (exp) localStorage.setItem('token_expires', String(exp * 1000));
};

const initOptions = {
    onLoad: undefined,
    pkceMethod: 'S256' as const,
    checkLoginIframe: false,
};

const authService = new AuthService();

const handleOnEvent = (event: string) => {
    if (event === 'onAuthSuccess') {
        persistTokens();
        void authService.finalizeSessionAfterLogin();
    }
    if (event === 'onAuthLogout') {
        void authService.completeLogout();
    }
};

const container = document.getElementById('root');

if (container) {
    createRoot(container).render(
        <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions} onEvent={handleOnEvent}>
            <App />
        </ReactKeycloakProvider>
    );
}
